module.exports = __webpack_public_path__ + "home/img/shield.315b768e.svg";